var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":_vm.route}},[_c('fa-layers',{staticClass:"fa-2x"},[_c('fa',{attrs:{"icon":['far','comment']}}),_vm._v(" "),_c('fa-layers-text',{staticClass:"gray8",attrs:{"transform":"up-1 shrink-10","value":_vm.notificationsCount}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }